<div class="time-wrapper" [ngClass]="{'time-wrapper--invalid': !isValid}">
  <span class="time-label">
    {{label ?? defaultLabel}}
    <span *ngIf="isRequired" class="required">*</span>
  </span>
  <app-ngb-timepicker
    class="mb-2"
    [disabled]="isDisabled"
    [ngModel]="time"
    (ngModelChange)="onChange($event)"
  ></app-ngb-timepicker>
</div>
